(function () {
  function stripInlineStyleNodes() {
    var selectors = [
      "article.article-template .article-template__content.rte",
      ".template-product .product__description.rte",
      ".template-product .product__description .rte",
      ".template-product .rte",
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (container) {
        container.querySelectorAll("style").forEach(function (n) {
          n.remove();
        });
      });
    });
  }
  function setBotaniqueArchiveNewWindow() {
    var anchors = document.querySelectorAll("a[href]");
    anchors.forEach(function (a) {
      var href = (a.getAttribute("href") || "").toLowerCase();
      var text = (a.textContent || "").toLowerCase().trim();
      var isBotaniqueLink =
        href.indexOf("redcrocusbotanique.com") !== -1 ||
        text === "redcrocus botanique archive";
      if (!isBotaniqueLink) return;
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer");
    });
  }
  function fixPlantDetailIcons() {
    var base = "https://cdn.shopify.com/s/files/1/0657/5806/8809/files/";
    var map = {
      "Botanical Name Icon": "botanical_name.png",
      "Common Name Icon": "common_name.png",
      "Size & Growth Icon": "size_growth.png",
      "Hardiness Zones Icon": "hardiness_zones.png",
      "Foliage Type Icon": "foliage_type.png",
      "Bloom Time Icon": "bloom_time.png",
      "Growth Rate Icon": "growth_rate.png",
      "Light Requirements Icon": "light_requirements.png",
      "Pollinators Icon": "attracts_pollinators.png",
      "Indoor Friendly Icon": "indoor_friendly.png",
      "Container Friendly Icon": "container_friendly.png",
      "Deer Resistant Icon": "deer_resistant.png",
      "Pet Warning Icon": "pet_warning.png",
      "Fragrant Icon": "fragrant.png",
      "Cut Flower Icon": "cut_flower.png",
      "Grows Well With Icon": "grows_well_with.png",
      "Planting Instructions Icon": "planting_instructions.png",
      "Soil Moisture Icon": "soil_moisture.png",
      "Soil Type Icon": "soil_type.png",
      "Humidity Icon": "humidity.png",
      "Pruning Instructions Icon": "pruning_instructions.png",
      "Winter Care Icon": "winter_care.png",
      "Planting Depth Icon": "planting_depth.png",
      "Fertilization Icon": "fertilization.png",
      "Special Care Icon": "special_care.png",
    };

    document.querySelectorAll('img[alt*="Icon"]').forEach(function (img) {
      var alt = (img.getAttribute("alt") || "").trim();
      var file = map[alt];
      if (!file) return;
      var fallback = base + file;
      var apply = function () {
        if (img.src !== fallback) img.src = fallback;
      };
      if (!img.getAttribute("src") || img.naturalWidth === 0) apply();
      img.addEventListener("error", apply, { once: true });
      img.style.setProperty("width", "1.8rem");
      img.style.setProperty("height", "1.8rem");
      img.style.setProperty("object-fit", "contain");
      img.style.setProperty("vertical-align", "middle");
      img.style.setProperty("margin-right", "0.4rem");
    });
  }
  function tunePreorderNoticeTypography() {
    document.querySelectorAll(".rc-preorder-notice").forEach(function (box) {
      box.style.setProperty("margin-top", "1rem", "important");
      box.style.setProperty("margin-bottom", "1.1rem", "important");
      box.style.setProperty("padding", "0.75rem 0.9rem", "important");
    });
    document.querySelectorAll(".rc-preorder-notice__title").forEach(function (el) {
      el.style.setProperty("font-size", "1.5rem", "important");
      el.style.setProperty("line-height", "1.3", "important");
      el.style.setProperty("font-weight", "700", "important");
    });
    document.querySelectorAll(".rc-preorder-notice__body").forEach(function (el) {
      el.style.setProperty("font-size", "1.35rem", "important");
      el.style.setProperty("line-height", "1.5", "important");
    });
  }
  function enhanceCommunityPhotoUploads() {
    var form = document.querySelector("form[data-community-form]");
    if (!form || form.querySelector("[data-rc-community-uploader]")) return;

    var primary = form.querySelector('input[type="file"][name="primary_image"]');
    var extra1 = form.querySelector('input[type="file"][name="extra_image_1"]');
    var extra2 = form.querySelector('input[type="file"][name="extra_image_2"]');
    if (!primary || !extra1 || !extra2) return;

    function closestBlock(el) {
      return el.closest(".community-form__grid") || el.closest("div") || el.parentElement;
    }
    [closestBlock(primary), closestBlock(extra1), closestBlock(extra2)].forEach(function (b) {
      if (b) b.style.display = "none";
    });

    primary.required = false;
    primary.removeAttribute("required");

    var wrap = document.createElement("section");
    wrap.className = "rc-community-uploader";
    wrap.setAttribute("data-rc-community-uploader", "1");
    wrap.innerHTML =
      '<div class="rc-community-uploader__header">' +
      '<h3 class="rc-community-uploader__title">Photos</h3>' +
      '<p class="rc-community-uploader__help">Upload multiple images at once. Works on mobile photo library and desktop drag/drop.</p>' +
      "</div>" +
      '<label class="rc-community-uploader__pick">' +
      '<input class="rc-community-uploader__input" type="file" accept="image/*" multiple>' +
      '<span class="rc-community-uploader__button">Choose photos</span>' +
      '<span class="rc-community-uploader__hint">No files selected</span>' +
      "</label>" +
      '<p class="rc-community-uploader__note">Supported: JPG, PNG, WEBP. First image is used as primary.</p>' +
      '<ul class="rc-community-uploader__list" hidden></ul>';

    var c = form.querySelector('input[name="consent"]');
    var consentSection = c;
    while (consentSection && consentSection.parentNode && consentSection.parentNode !== form) {
      consentSection = consentSection.parentNode;
    }
    if (consentSection && consentSection.parentNode === form) {
      form.insertBefore(wrap, consentSection);
    } else {
      var tipsTa = form.querySelector('textarea[name="tips_learned"]');
      var afterTips = tipsTa ? (tipsTa.closest("div") || tipsTa.parentElement) : null;
      if (afterTips && afterTips.parentNode) {
        afterTips.parentNode.insertBefore(wrap, afterTips.nextSibling);
      } else {
        var submit = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submit && submit.parentElement) submit.parentElement.insertBefore(wrap, submit);
        else form.appendChild(wrap);
      }
    }

    var picker = wrap.querySelector(".rc-community-uploader__input");
    var hint = wrap.querySelector(".rc-community-uploader__hint");
    var list = wrap.querySelector(".rc-community-uploader__list");

    function setInputFile(input, file) {
      var dt = new DataTransfer();
      if (file) dt.items.add(file);
      input.files = dt.files;
    }

    function clearDynamic() {
      form.querySelectorAll('input[type="file"][data-rc-dynamic-extra="1"]').forEach(function (el) {
        el.remove();
      });
    }

    function renderList(files) {
      list.innerHTML = "";
      if (!files.length) {
        list.hidden = true;
        return;
      }
      list.hidden = false;
      files.forEach(function (f, idx) {
        var li = document.createElement("li");
        li.textContent = (idx + 1) + ". " + f.name;
        list.appendChild(li);
      });
    }

    picker.addEventListener("change", function () {
      var files = Array.from(picker.files || []);
      clearDynamic();
      setInputFile(primary, files[0] || null);
      setInputFile(extra1, files[1] || null);
      setInputFile(extra2, files[2] || null);
      files.slice(3).forEach(function (file, i) {
        var input = document.createElement("input");
        input.type = "file";
        input.name = "extra_image_" + (i + 3);
        input.setAttribute("data-rc-dynamic-extra", "1");
        input.hidden = true;
        form.appendChild(input);
        setInputFile(input, file);
      });
      hint.textContent = files.length ? files.length + " file(s) selected" : "No files selected";
      renderList(files);
    });
  }
  stripInlineStyleNodes();
  setBotaniqueArchiveNewWindow();
  tunePreorderNoticeTypography();
  fixPlantDetailIcons();
  enhanceCommunityPhotoUploads();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", stripInlineStyleNodes);
    document.addEventListener("DOMContentLoaded", setBotaniqueArchiveNewWindow);
    document.addEventListener("DOMContentLoaded", tunePreorderNoticeTypography);
    document.addEventListener("DOMContentLoaded", fixPlantDetailIcons);
    document.addEventListener("DOMContentLoaded", enhanceCommunityPhotoUploads);
  }
  window.addEventListener("load", stripInlineStyleNodes);
  window.addEventListener("load", setBotaniqueArchiveNewWindow);
  window.addEventListener("load", tunePreorderNoticeTypography);
  window.addEventListener("load", fixPlantDetailIcons);
  window.addEventListener("load", enhanceCommunityPhotoUploads);
  setTimeout(stripInlineStyleNodes, 0);
  setTimeout(stripInlineStyleNodes, 50);
  setTimeout(setBotaniqueArchiveNewWindow, 0);
  setTimeout(setBotaniqueArchiveNewWindow, 50);
  setTimeout(tunePreorderNoticeTypography, 0);
  setTimeout(tunePreorderNoticeTypography, 50);
  setTimeout(fixPlantDetailIcons, 0);
  setTimeout(fixPlantDetailIcons, 120);
  setTimeout(enhanceCommunityPhotoUploads, 0);
  setTimeout(enhanceCommunityPhotoUploads, 120);
})();
